import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const CardLink = styled(Link)`
  display: block;
  text-decoration: none;
  color: inherit;

  border: 1px solid #e5e7eb;
  border-radius: 22px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.06);

  transition: transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 18px 55px rgba(0, 0, 0, 0.10);
    border-color: rgba(15, 118, 110, 0.25);
  }

  &:focus-visible {
    outline: 2px solid rgba(15, 118, 110, 0.45);
    outline-offset: 4px;
  }
`;

const ImgWrap = styled.div`
  position: relative;
  background: #000;
  height: 190px;
`;

const Img = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transform: scale(1.02);
  transition: transform 220ms ease, filter 220ms ease;
  filter: saturate(1.02);

  ${CardLink}:hover & {
    transform: scale(1.08);
    filter: saturate(1.08);
  }
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0,0,0,0.08), rgba(0,0,0,0.62));
`;

const Badge = styled.div`
  position: absolute;
  left: 12px;
  top: 12px;
  padding: 8px 12px;
  border-radius: 999px;
  font-weight: 950;
  font-size: 12px;
  color: #fff;

  background: rgba(11, 18, 32, 0.60);
  border: 1px solid rgba(255,255,255,0.18);
  backdrop-filter: blur(8px);
`;

const Body = styled.div`
  padding: 14px 14px 16px;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 950;
  color: #111827;
  line-height: 1.25;
`;

const MetaRow = styled.div`
  margin-top: 10px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  padding: 8px 12px;
  border-radius: 999px;

  font-weight: 950;
  font-size: 12px;
  color: #0f766e;
  background: rgba(15, 118, 110, 0.10);
  border: 1px solid rgba(15, 118, 110, 0.20);
`;

const Text = styled.p`
  margin: 10px 0 0;
  color: #4b5563;
  line-height: 1.6;
  font-size: 14px;
`;

const Hint = styled.div`
  margin-top: 12px;
  font-weight: 900;
  color: #111827;
  opacity: 0.85;
`;

export default function CourseCard({
  id,
  title,
  subtitle,
  imageUrl,
  holes,
  typeLabel,
  to,
}) {
  return (
    <CardLink to={to} aria-label={`Öppna ${title}`}>
      <ImgWrap>
        {imageUrl && <Img src={imageUrl} alt={title} loading="lazy" />}
        <Overlay />
        <Badge>Hofors BGK</Badge>
      </ImgWrap>

      <Body>
        <Title>{title}</Title>

        <MetaRow>
          {typeof holes === "number" && <Chip>{holes} hål</Chip>}
          {typeLabel && <Chip>{typeLabel}</Chip>}
        </MetaRow>

        {subtitle && <Text>{subtitle}</Text>}
        <Hint>Läs mer →</Hint>
      </Body>
    </CardLink>
  );
}
